import { createSelector } from "@ngrx/store";
import { SelectSupplierModuleState } from "../suppliermodule.selector";


export const GetCurrentSupplierCode = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.currentSupplierCode
);

export const GetSupplierType = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.supplierType
);

export const GetSupplierCategory = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.supplierCategory
);

export const GetOnboardingVendorCountry = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.vendorCountry
);

export const GetErrorMessage = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.errorMessage
);

export const GetRegionCode = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.regionCode
);

export const GetSupplierDetails = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.supplierDetails
);

export const GetSupplierAddress = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.supplierAddress
);

export const GetSupplierContacts = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.supplierContacts
);

export const GetSupplierBank = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.supplierBank
);

export const GetSupplierTax = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.supplierTax
);

export const GetDocumentInformation = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.documentInfo
);

export const GetCompleteRegistration = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.completeRegistration
);

export const GetCompletedTabs = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.completedTabs
);

export const GetRejectedTabs = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.rejectedTabs
);

export const GetCurrentTabRejection = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.currentTabRejection
);

export const GetCurrentTab = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.currentTab
);

export const GetNextAvailableTab = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.nextAvailableTab
);

export const GetCurrentTabStatus = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.currentTabStatus
);

export const GetOnboardingStepsStateFlag = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.receivedOnboardingStepsState
);

export const GetOnboardingEnabledFlag = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.isClmEnabled
);

export const GetOnboardingRequiredSteps = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.requiredOnboardingSteps
);

export const GetExtendedOnboardingTrainingDocuments = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.trainingDocs.extended
);

export const GetInitialOnboardingTrainingDocuments = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.trainingDocs.initial
);

export const GetSupplierEhsResponse = createSelector(
    SelectSupplierModuleState,
    state => state.OnboardingState.ehsResponse
);